import React, { useState, useEffect } from "react";
import Image from "../assets/image.jpg";
import { useNavigate } from "react-router-dom";
import Benefit1 from '../assets/Benefit-1.svg';
import Benefit2 from '../assets/Benefit-2.svg';
import Benefit3 from '../assets/Benefit-3.svg';
import aadhaar from '../assets/aadhaar.svg';
import secureStorage from "../utils/secureStorage";

const Dashboard = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const navigate = useNavigate();

    const handleAadhaarClick = () => {
        navigate("/healthacnt");
    };

    const handleLoginClick = () => {
        navigate("/abhalogin");
    };

    const handleHospitalLoginClick = () => {
        navigate("/login");
    };

    useEffect(() => {
        validateToken();
    });

    const validateToken = async () => {
        try {
            const token = secureStorage.get("authToken");
            const clinicId = secureStorage.get("clinic");
            if (!token) {
                console.log("No token");
                return;
            }

            const response = await fetch(
                `${API_URL}hospital/validate`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "X-HIP-ID":clinicId,
                    },
                }
            );

            if (response.ok) {
                console.log("Successful.");
                navigate("/hospital-dashboard");
            } else if (response.status === 401) {
                console.error("Unauthorized. Clearing localStorage.");
                localStorage.clear();
            } else {
                console.error("Failed to fetch appointments:", response.statusText);
            }
        } catch (error) {
            console.error("Error occurred while fetching appointments:", error);
            localStorage.clear();
        } finally {
            console.log("API request completed.");
        }
    };

    return (
        <div className="bg-gradient-to-r from-blue-500 to-teal-500 min-h-screen">
            {/* Header Section */}


            <section className="container mx-auto px-6 py-12 text-white">
                <div className="flex flex-col lg:flex-row items-center">

                    <div className="w-full lg:w-1/2 text-center lg:text-left">
                        <h2 className="text-4xl font-bold mb-4">
                            Create Your Digital Health Account
                        </h2>
                        <p className="text-lg mb-6">
                            Secure your health journey with our digital platform. Manage your
                            records, access personalized care, and connect with trusted
                            providers.
                        </p>

                        <div className="flex flex-col md:flex-row md:space-x-4 justify-center lg:justify-start">
                            {/* <button
                                onClick={openModal}
                                className="px-6 py-3 bg-white text-blue-500 rounded-lg shadow-md hover:bg-gray-100 font-semibold"
                            >
                                Create Health Account
                            </button>
                            <button
                                className="px-6 py-3 bg-white text-blue-500 rounded-lg shadow-md hover:bg-gray-200 font-semibold mt-4 md:mt-0"
                                onClick={handleLoginClick}
                            >
                                Login
                            </button> */}
                            <button
                                onClick={handleHospitalLoginClick}
                                className="px-6 py-3 bg-white text-blue-500 rounded-lg shadow-md hover:bg-gray-100 font-semibold"
                            >
                                Partner Login
                            </button>
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2 mt-8 lg:mt-0 relative">
                        <div className="relative">

                            <img
                                src={Image}
                                alt="Healthcare Illustration"
                                className="rounded-lg shadow-lg"
                            />
                            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white opacity-50 rounded-lg"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="bg-white py-12">
                <div className="container mx-auto px-6">
                    <h3 className="text-3xl font-bold text-center text-teal-600 mb-8">
                        Benefits of Digital Health Account
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="text-center p-6 border rounded-lg shadow-md hover:shadow-lg">
                            <img
                                src={Benefit1}
                                alt="Benefit 1"
                                className="mx-auto mb-4"
                            />
                            <h4 className="text-lg font-bold mb-2">Personalized Health Records</h4>
                            <p className="text-gray-600">
                                Access and manage your medical records anytime, anywhere.
                            </p>
                        </div>
                        <div className="text-center p-6 border rounded-lg shadow-md hover:shadow-lg">
                            <img
                                src={Benefit2}
                                alt="Benefit 2"
                                className="mx-auto mb-4"
                            />
                            <h4 className="text-lg font-bold mb-2">Seamless Doctor Consultations</h4>
                            <p className="text-gray-600">
                                Connect with trusted healthcare providers effortlessly.
                            </p>
                        </div>
                        <div className="text-center p-6 border rounded-lg shadow-md hover:shadow-lg">
                            <img
                                src={Benefit3}
                                alt="Benefit 3"
                                className="mx-auto mb-4"
                            />
                            <h4 className="text-lg font-bold mb-2">Secure Data Sharing</h4>
                            <p className="text-gray-600">
                                Share your health data securely with specialists.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <>
                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg p-8 max-w-lg w-full">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-2xl font-bold text-teal-600">
                                    Create ABHA Number
                                </h2>
                                <button
                                    onClick={closeModal}
                                    className="text-gray-600 hover:text-gray-900 text-xl font-bold"
                                >
                                    &times;
                                </button>
                            </div>
                            <p className="text-gray-700 mb-6">
                                Please choose the option below to start with the creation of your ABHA.
                            </p>

                            <div
                                className="flex flex-col items-center justify-center border-2 border-gray-300 rounded-lg p-4 shadow-md hover:shadow-lg hover:border-teal-600 transition-transform transform hover:scale-105 cursor-pointer"
                                onClick={handleAadhaarClick}
                            >
                                <img
                                    src={aadhaar}
                                    alt="Aadhaar"
                                    className="w-16 h-16 mb-4"
                                />
                                <h3 className="text-teal-600 font-semibold">Aadhaar</h3>
                            </div>

                            <p className="text-center text-gray-600 mt-6 font-semibold">
                                Already have an ABHA number?{" "}
                                <a href="/abhalogin" className="text-teal-600 underline">
                                    Login
                                </a>
                            </p>
                        </div>
                    </div>
                )}
            </>



            {/* Footer Section */}
            <footer className="bg-teal-700 text-white py-6">
                <div className="container mx-auto text-center">
                    <p>&copy; 2024 Digital Health Platform. All Rights Reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Dashboard;
